<script lang="ts">
    import type {ModalWindowActions} from 'shared/modal-dialogs';
    import type {ReferencesDateSelectionModalModel} from '../types';
    import {createPayloadActionResponse} from 'src/modals/modal-utils';
    import {exists} from 'shared/utils/custom-utils';
    import KpModalHeaderCloseButton from 'src/modals/kp-modal/KpModalHeaderCloseButton.svelte';
    import KpModalContent from 'src/modals/kp-modal/KpModalContent.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import KpValueEditor from 'shared/value-editors/kp-value-editor/KpValueEditor.svelte';
    import KpValueEditorForceSettings from 'shared/value-editors/kp-value-editor-force-settings/KpValueEditorForceSettings.svelte';

    export let model: ReferencesDateSelectionModalModel;
    export let modalWindowActions: ModalWindowActions;

    let selectedDate = null;

    const handleContinueWithoutDate = () => {
        modalWindowActions.return(createPayloadActionResponse(null));
    };

    const handleSubmit = () => {
        if (!exists(selectedDate)) {
            return;
        }

        modalWindowActions.return(createPayloadActionResponse(selectedDate));
    };
</script>

<KpModalContent {modalWindowActions} additionalClasses="sutor-references-date-selection-modal">
    <svelte:fragment slot="header">
        <div class="modal-title">
            <h1>
                Vyberte datum průvodek
            </h1>

            <small class="text-muted">
                Počet nahraných průvodek: {model.files.length}
            </small>

            <small class="text-danger">
                Když žádné nevyberete, datumové pole nebude vyplněno. Datum můžete změnit později.
            </small>
        </div>

        <KpModalHeaderCloseButton/>
    </svelte:fragment>

    <svelte:fragment slot="body">
        <KpValueEditorForceSettings forceSettings={[{type: 'date', options: {onlyDate: true}}]}>
            <KpValueEditor type="date" bind:model={selectedDate}/>
        </KpValueEditorForceSettings>
    </svelte:fragment>

    <svelte:fragment slot="footer">
        <KpButton on:click={handleContinueWithoutDate}>
            Pokračovat bez vybrání datumu
        </KpButton>

        <KpButton isDisabled={!exists(selectedDate)} buttonStyle="success" on:click={handleSubmit}>
            Použít vybrané datum
        </KpButton>
    </svelte:fragment>
</KpModalContent>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .modal-title {
        display: flex;
        flex-direction: column;
        gap: @spacing-s;

        h1 {
            margin: 0;
            font-size: 1.3em;
        }
    }
</style>